import { render, staticRenderFns } from "./Register-user.vue?vue&type=template&id=c4e3953a"
import script from "./Register-user.vue?vue&type=script&lang=js"
export * from "./Register-user.vue?vue&type=script&lang=js"
import style0 from "./Register-user.vue?vue&type=style&index=0&id=c4e3953a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports